// Durée en millisecondes la plus longue d'une valeur CSS `transition-duration`
// (« 0.15s », « 300ms », « 0.15s, 0.3s »), 0 sans transition.
export function parseTransitionDuration(value: string): number {
  const durations = value.split(',').map((duration) => {
    const trimmed = duration.trim();
    const number = parseFloat(trimmed);

    return trimmed.endsWith('ms') ? number : number * 1000;
  });

  return Math.max(
    0,
    ...durations.filter((duration) => !Number.isNaN(duration))
  );
}

// Exécute `callback` une fois la transition CSS de l'élément terminée. Un
// minuteur calé sur la durée déclarée plutôt que l'événement `transitionend`,
// qui ne vient pas si aucune propriété ne change réellement (élément non
// affiché, ou dont une règle plus spécifique fige la valeur animée). Retourne
// une fonction d'annulation.
export function afterTransition(
  element: Element,
  callback: () => void
): () => void {
  const duration = parseTransitionDuration(
    getComputedStyle(element).transitionDuration
  );
  const timer = setTimeout(callback, duration);

  return () => clearTimeout(timer);
}
